import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import omit from 'lodash/omit';
import qs from 'qs';

const withQueryParams = compose(
  withRouter,
  withProps(props => ({
    queryParams: qs.parse(props.history.location.search, {
      ignoreQueryPrefix: true,
    }),
  })),
  withHandlers({
    updateQueryParams: props => params => {
      const newParams = {
        ...qs.parse(props.history.location.search, {
          ignoreQueryPrefix: true,
        }),
        ...props.queryParams,
        ...params,
      };
      const newQuery = qs.stringify(newParams, { addQueryPrefix: true });
      if (newQuery !== props.history.location.search) {
        props.history.push({ search: newQuery });
      }
    },
    removeQueryParams: props => keys => {
      const newParams = omit(props.queryParams, keys);
      const newQuery = qs.stringify(newParams, { addQueryPrefix: true });
      if (newQuery !== props.history.location.search) {
        props.history.push({ search: newQuery });
      }
    },
  }),
);

export default withQueryParams;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withQueryParams.js